import { useTenant } from "../../../Contexts/TenantContext";
import { PolicyType } from "../../../Enums/PolicyType";
import { InfoBox } from "../../../Components/InfoBox/InfoBox";
import SmartNavbar from "../../../Components/SmartNavbar/SmartNavbar";
import Banner from "../../../Components/Banner/Banner";
import PoliciesLinks from "../../../Components/PoliciesLinks/PoliciesLinks";
import PolicyAccordionItem from "../../../Components/PolicyAccordionItem/PolicyAccordionItem";
import Footer from "../../../Components/Footer/Footer";

const UserPoliciesPage = () => {
  const { tenant, tenantContact } = useTenant();

  return (
    <div>
      <SmartNavbar />
      <div className={`w-full bg-gray-50`}>
        <Banner
          title="Políticas do Site"
          description="Caro Cliente, aqui você encontrará informações importantes sobre os seus direitos e obrigações, bem como dos procedimentos a serem adotados. Tais informações são importantes, assim, pedimos que você as leia com toda atenção."
        />
        <div className={`w-full flex flex-col md:flex-row gap-4 md:gap-6 page-gutter py-6 xl:px-36`}>
          {/* Mobile policies on top */}
          <div className="flex md:hidden justify-between mb-4">
            <PoliciesLinks excludedPolicy={PolicyType.Policies} isMobile />
          </div>

          {/* Desktop sidebar */}
          <div className={`hidden md:block flex-[0.4] `}>
            <PoliciesLinks excludedPolicy={PolicyType.Policies} />
          </div>

          {/* Accordion items */}
          <div className={`flex flex-col flex-[1.6] gap-2 `}>
            <div className={`leading-normal md:text-justify mb-4 text-xs text-gray-800`}>
              <p className="mb-2">Caro Cliente, aqui você encontrará informações importantes sobre os seus direitos, obrigações e procedimentos. Pedimos que você leia com atenção e, em caso de dúvida, entre em contato através dos nossos Canais de Atendimento disponíveis em nosso site e no item 6 deste documento.</p>
              <p>O Cliente (e seu responsável legal, se o caso) é o único responsável pela veracidade e legalidade dos dados e informações prestadas para fins de cadastro e compras na plataforma E-commerce {tenant?.companyName}.</p>
            </div>
            <div className="flex flex-col gap-2 md:gap-4">
              <PolicyAccordionItem
                index={1}
                title="Cadastro"
                content={
                  <>
                    <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                      <p className="mb-5">
                        Para adquirir produtos da {tenant.companyName}, o usuário deverá criar uma conta em nosso site. 
                        Para isso, é necessário acessar a tela de registro de conta. Após o cadastro, o usuário poderá acessar a plataforma através da tela de login.
                      </p>

                      <div className="mb-5">
                        <h4 className="font-extrabold mb-1">Pessoa Física (PF)</h4>
                        <p className="mb-3">
                          Contas do tipo Pessoa Física requerem que o usuário informe os seguintes dados:
                        </p>
                        <InfoBox title="Informações" type="info">
                          E-mail, número de telefone, nome completo, CPF, RG, data de nascimento e gênero.
                        </InfoBox>
                      </div>

                      <div className="mb-5">
                        <h4 className="font-extrabold mb-1">Pessoa Jurídica (PJ)</h4>
                        <p className="mb-3">
                          Contas do tipo Pessoa Jurídica requerem que o usuário informe os seguintes dados:
                        </p>
                        <InfoBox title="Informações" type="info">
                          E-mail, número de telefone, razão social, nome fantasia, CNPJ, inscrição estadual, inscrição municipal e data de fundação.
                        </InfoBox>
                      </div>
                    </div>
                  </>
                }
              />

              <PolicyAccordionItem
                index={2}
                title="Pedido"
                content={
                  <>
                    <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                      <ol className="list-decimal list-inside space-y-5 mb-5">
                        <li>
                          Os pedidos somente serão considerados válidos quando realizados por meio do nosso site oficial https://{tenant.domain} ("site oficial"). A {tenant.companyName} não reconhece e não se responsabiliza por qualquer compra feita em outro site que não o seu site oficial, ou, ainda, por eventuais alterações e/ou fraudes ocorridas no computador, tablet, celular do Cliente e/ou qualquer outro meio de acesso à internet.
                          <br />
                          Por questões de segurança, para a criação de cadastro na {tenant.companyName} é necessário a inclusão de endereço de e-mail válido. Endereços de e-mails temporários e/ou com extensões inexistentes (domínios incorretos) não são considerados endereços válidos, impedirá a conclusão do cadastro do cliente e/ou facultará o seu cancelamento pela {tenant.companyName}.
                        </li>
                        <li>
                          Após a criação e confirmação do pedido, o Cliente receberá uma mensagem através do e-mail de cadastro com confirmação e número do pedido.
                        </li>
                        <li>
                          <strong>ATENÇÃO:</strong> O Cliente deverá acompanhar o recebimento do e-mail de confirmação do pedido acima informado, e verificar se o pedido corresponde exatamente à compra realizada, nos detalhes do pedido pelo site. Caso exista qualquer divergência, o Cliente deverá entrar em contato através de nossos Canais de Atendimento para análise e eventual correção interna. O mesmo se aplica no caso de, ultrapassado o prazo de 24 horas, o Cliente não ter recebido o e-mail com a confirmação do pedido.
                        </li>
                        <li>
                          A {tenant.companyName} possui diversas discussões judiciais referente a restituição de tributos pagos a maior ou indevidamente e, conforme o Código Tributário Nacional, para que tais restituições sejam efetivadas é fundamental a concordância do consumidor final. Desta forma, ao realizar compras na {tenant.companyName} e, sendo assim, aceitando as políticas do site, você expressamente autorizará o KaBuM! a restituir para si integralmente os valores sujeitos a qualquer ressarcimento.
                        </li>
                      </ol>
                    </div>
                  </>
                }
              />

              <PolicyAccordionItem
                index={3}
                title="Formas de Pagamento"
                content={
                  <>
                    <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                      <ol className="list-decimal list-inside space-y-5 mb-5">
                        <li>
                          O Cliente poderá pagar suas compras de acordo com as opções dispostas para cada produto comercializado no site da {tenant.companyName}, a exemplo, por PIX (QR CODE ou Código PIX), cartão de crédito, cujas bandeiras e margens de descontos estão ostensivamente explícitas ao Cliente, boleto bancário, e as opções serão disponibilizadas no ato de compra.
                          A {tenant.companyName} não garante que todas as formas de pagamento estarão disponíveis para todos os produtos, instituições financeiras e/ou bandeiras de cartões de crédito. A possibilidade de parcelamento, número de parcelas e a incidência de juros, pode variar de acordo com o produto. Para saber quais as formas de pagamento disponíveis e as opções de parcelamento (se existirem), verifique as condições ativas na página do produto desejado.

                          <ol className="list-[lower-alpha] list-inside ml-2 mt-3">
                            <li className="mb-3">
                              <strong>PIX</strong> (QR Code e Código PIX)

                              <ol className="list-[lower-roman] list-inside space-y-3 ml-5 mt-3">
                                <li>
                                  O pagamento por PIX deve ser efetuado dentro do prazo de 30 minutos após concluída a compra. Decorrido 30 minutos, o QR Code e Código gerado expira e o pedido é automaticamente cancelado.
                                </li>
                                <li>
                                  Atenção: a {tenant.companyName} não aceita PIX Transferência (transferência entre contas com PIX sem uso do QR Code ou Código PIX), como forma de pagamento.
                                </li>
                              </ol>
                            </li>
                            <li className="mb-3">
                              <strong>Cartão de Crédito</strong>

                              <ol className="list-[lower-roman] list-inside space-y-3 ml-5 mt-3">
                                <li>
                                  Para os pagamentos via cartão de crédito, o Cliente deverá se utilizar, preferencialmente, de cartão de crédito de sua titularidade, se responsabilizando pelo seu uso correto. Caso o Cliente utilize cartão de crédito de terceiros, ele se responsabilizará em obter a autorização expressa do respectivo titular do cartão de crédito para a realização da compra no site da {tenant.companyName}.
                                </li>
                                <li>
                                  Fica facultado a {tenant.companyName} solicitar todas e quaisquer informações necessárias para confirmar a autorização do titular do cartão.
                                </li>
                                <li>
                                  O Cliente que se utilizar do cartão de crédito de terceiros sem a devida autorização do proprietário, se responsabilizará por todo e qualquer prejuízo causado a {tenant.companyName} e/ou a terceiros, sem prejuízo das sanções administrativas e legais aplicáveis.
                                </li>
                                <li>
                                  O Cliente deve se atentar ao limite de seu cartão que é estabelecido pela própria administradora.
                                </li>
                              </ol>
                            </li>
                            <li className="mb-3">
                              <strong>Boleto Bancário</strong>

                              <ol className="list-[lower-roman] list-inside space-y-3 ml-5 mt-3">
                                <li>
                                  A {tenant.companyName} poderá ainda, a qualquer tempo e a seu exclusivo critério, disponibilizar ao cliente a forma de pagamento por meio de boleto bancário e esta opção, se ativa, estará disposta na etapa de pagamento. Quando e se disponibilizado o pagamento por meio de Boleto Bancário e esta for a escolha do Cliente, o Cliente deverá clicar na opção CLIQUE AQUI PARA VISUALIZAR O BOLETO e conferir a data de vencimento, os dados do pedido, valor e endereço de entrega, bem como se certificar que a linha de pagamento não foi alterada por vírus decorrentes do seu equipamento. Em caso de dúvida, o Cliente deverá entrar em contato com a {tenant.companyName} através de nossos Canais de Atendimento.
                                </li>
                              </ol>
                            </li>
                            <li>
                              <strong>Confirmação de Pagamento</strong>

                              <ol className="list-[lower-roman] list-inside space-y-3 ml-5 mt-3">
                                <li>
                                  A liberação do pedido para remessa e postagem está condicionada às políticas internas de cada instituição financeira e, portanto, <strong>caso a compra não seja autorizada pela instituição, seja qual for o motivo, poderá haver o cancelamento do pedido</strong> feito por qualquer meio de pagamento (PIX, cartão de crédito, boleto bancário).
                                  <br />
                                  Atenção: Pagamentos efetuados via Boleto Bancário e Cartão de Crédito têm prazo de 1 a 2 dias úteis para confirmação; já para pagamentos via PIX, o prazo de confirmação é de até 30 minutos. Se esse período for expirado e o pagamento de seu pedido permanecer indicado como pendente, é necessário que você entre em contato com o nosso Atendimento.
                                </li>
                                <li>
                                  A {tenant.companyName} reserva-se no direito de, antes de confirmar o pedido, solicitar prévia validação e autorização das administradoras de cartão de crédito, bem como solicitar a confirmação e o comprovante de pagamento do PIX e do boleto bancário, não se responsabilizando por eventuais fraudes ocorridas.
                                </li>
                                <li>
                                  Referente à modalidade PIX, fica a critério de cada instituição financeira estabelecer um limite máximo para a realização de pagamentos. Portanto, fica sob responsabilidade do cliente se informar a respeito dessa condição, junto ao seu banco.
                                </li>
                                <li>
                                  A {tenant.companyName}, a fim de evitar prejuízos aos seus Clientes e/ou ao sistema financeiro, se reserva no direito de cancelar a operação de compra, bem como bloquear a respectiva entrega do produto quando for comunicado pela operadora de cartão de crédito que houve a utilização indevida ou por qualquer meio legal que ateste a suspeita de fraude ou de uso indevido. Nesta hipótese, a {tenant.companyName} não será responsável por qualquer dano causado ao Cliente em decorrência de tal cancelamento.
                                </li>
                                <li>
                                  Na hipótese da {tenant.companyName} ser comunicada acerca da utilização indevida do cartão de crédito após a conclusão da operação de compra e entrega do produto ao Cliente, a {tenant.companyName} adotará todas as providências legais para averiguar o ocorrido, inclusive de cunho penal, a fim de obter o recebimento do crédito decorrente da venda dos produtos.
                                </li>
                                <li>
                                  O Cliente se compromete a evitar e minimizar a ocorrência de fraudes de qualquer tipo, inclusive mantendo o equipamento utilizado para a compra livre de vírus, malwares, spyware e/ou qualquer outra forma de adulteração das informações contidas na página da {tenant.companyName}.
                                </li>
                              </ol>
                            </li>  
                          </ol>
                        </li>
                      </ol>               
                    </div>
                  </>
                }
              />

              <PolicyAccordionItem
                index={4}
                title="Entrega"
                content={
                  <>
                    <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                      <ol className="list-decimal list-inside space-y-5 mb-5">
                        <li>
                          O prazo de entrega, informado no momento da compra, para qualquer modalidade de frete escolhido, é contado a partir da confirmação de pagamento e trata-se apenas de uma previsão, podendo ser alterado por fatores alheios ao controle da {tenant.companyName}.
                        </li>
                        <li>
                          A {tenant.companyName} não se responsabiliza pelo não cumprimento dos prazos de entrega, especialmente nos seguintes exemplos, mas não se limitando à: endereço de entrega informado incorretamente, incompleto, desatualizado, endereço com restrição de entrega pela transportadora, seja por ser região de risco ou inacessível, Cliente ausente, recusa em receber os produtos por parte do Cliente ou terceiros localizados no endereço da entrega, mudança de endereço sem a devida notificação a {tenant.companyName}, endereços fechados, em caso fortuito, força maior e fatos de terceiros.
                        </li>
                        <li>
                          A {tenant.companyName} não se responsabiliza pelo não cumprimento do prazo estabelecido quando o Cliente residir em áreas de risco ou em áreas posteriormente determinadas pelas empresas transportadoras como "áreas de entrega com prazo diferenciado". Nessas situações, cabe ao Cliente averiguar se se enquadra em alguma dessas situações antes de finalizar a compra.
                        </li>
                        <li>
                          O Cliente será responsável pelo pagamento do frete de nova postagem quando houver recusa injustificada do recebimento do produto.
                        </li>
                        <li>
                          O Cliente poderá optar, no momento da formalização do pedido, pelo modelo de frete, se disponível, a ser contratado para o envio da mercadoria. O cliente deverá se atentar não só para os preços, mas também aos prazos e condições de entrega.

                          <ol className="list-[lower-alpha] list-inside ml-5 mt-3">
                            <li>
                              Algumas mercadorias estão sujeitas a alteração da forma de postagem, arcando a {tenant.companyName} com eventual custo adicional.
                            </li>
                          </ol>
                        </li>
                      </ol>               
                    </div>
                    
                    <InfoBox type="warning">
                      A {tenant.companyName} não se responsabiliza pela retenção de mercadorias na SEFAZ quando esta se der exclusivamente de obrigação imposta pela Administração Pública ao Cliente, sendo, portanto, necessário seu comparecimento no posto fiscal para que a mercadoria seja liberada, tendo em vista que nestes casos as informações referentes a liberações e pagamentos só são passadas aos interessados.
                    </InfoBox>
                  </>
                }
              />

              <PolicyAccordionItem
                index={5}
                title="Produto em desacordo com o pedido"
                content={
                  <>
                    <div className="text-xs md:text-sm text-gray-800 leading-normal md:text-justify">
                      <ol className="list-decimal list-inside space-y-5">
                        <li>
                          O Cliente ou o terceiro deverá conferir, no ato do recebimento, se o(s) produto(s) é o adquirido e descrito na nota fiscal. Caso seja constatado que o produto entregue não é o mesmo que o adquirido, o Cliente ou o terceiro, deverá recusar seu recebimento e entrar em contato através dos Canais de Atendimento em até de 48 (quarenta e oito) horas a contar do ato do recebimento.
                        </li>
                        <li>
                          Caso o Cliente venha a receber o produto e constate que o produto recebido não é o adquirido e descrito na Nota Fiscal, o Cliente se compromete a devolver/entregar o Produto a {tenant.companyName} ou a quem esse indicar (Transportadoras), no mesmo estado em que recebeu, se comprometendo ainda a indenizar a {tenant.companyName} dos prejuízos ocasionados por negligência, má utilização, guarda inadequada, desleixo ou outro dano que possa decorrer, direta ou indiretamente, de sua ação ou omissão e, a não devolução do Produto acarretará o pagamento do valor do produto recebido a {tenant.companyName}, sem prejuízo de responder pelas perdas e danos ocasionados a esse.
                        </li>
                      </ol>
                    </div>
                  </>
                }
              />

              <PolicyAccordionItem
                index={6}
                title="Canais de Atendimento"
                content={
                  <>
                    <div className="text-xs md:text-sm text-gray-800 leading-normal">
                      <p className="md:text-justify mb-2">A {tenant.companyName} disponibiliza a todos os seus clientes os seguintes canais de atendimento:</p>
                      <ul className="list-disc list-inside space-y-2 ml-1">
                        {tenantContact.phoneNumber && (
                          <li>Central de Atendimento: {tenantContact.phoneNumber}</li>
                        )}
                        <li>
                          E-mail do Atendimento: <a href={tenantContact.email} className="text-primary-600 underline"> {tenantContact.email}</a>
                        </li>
                      </ul>
                    </div>
                  </>
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserPoliciesPage;
